import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import utils from '../../utils/config.js';

class Donate extends Component {
    render() {
      var style = {
      maxWidth: '500px',
      minWidth: '310px',
      maxHeight : 'none!important',
    }
    var appName = utils.getAppName();
        return (
            <div>
                <form className="bodyText">
                  <span className="headerText">Donate</span>
                  <br/><br/>
                <p>{appName} is a free service provided by Gears of War veteran and analyst, Rob "Immortal Spawn" Ambrose. 
                <br/>
                Show your support by making a donation to the project! You contribution helps keep </p>
                    <br/><br/>
                  <center>
                  <script src="https://donorbox.org/widget.js" paypalExpress="true">
                    </script>
                    <iframe src="https://donorbox.org/embed/thank-you-10?amount=null" height="685px" width="100%" style={style} seamless="seamless" name="donorbox" frameBorder="0" scrolling="no" allowpaymentrequest></iframe>                   
               </center>
                </form>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(Donate);



// WEBPACK FOOTER //
// ./src/app/components/donate/index.jsx